import { createApp, watch } from 'vue';
import App from './App.vue';
import router from './router/router.js';
import store from './store/store.js';
//import axios from 'axios';
import axios from '@/js/axiosConfig'; //헤더정보에 Language 설정을 위해 변경
// 해외법인 작업 수정(다국어 처리)
import i18n from './js/i18n';

import { componentPermission } from '@/js/permission';
import { callRefreshTokenSingleton } from '@/composables/refreshTokenCallSingleton';
import 'reset-css';
import './assets/css/app.css';
import './assets/css/reset.css';
import './assets/css/common.css';
import './assets/css/font/font.css';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

// Quasar
import { Quasar } from 'quasar';

const app = createApp(App);

app.use(router).use(store).use(Quasar).use(i18n).use(Toast, 
{
    position: 'bottom-center',
    toastDefaults: {
        default: {
            style: {
                fontSize: '4px',
            }
        },
    }
}).use(VCalendar, 
{
    locales: {
      'ko-KR': {
        firstDayOfWeek: 0, // 주의 시작 요일 설정 (0: 일요일)
        masks: {
            L: 'YYYY-MM-DD',
            title: 'MMMM YYYY',
            weekdays: 'W' 
          // 더 많은 마스크 포맷을 여기에 추가할 수 있습니다.
        }
      },
      'en-US': {
        firstDayOfWeek: 0, // 주의 시작 요일 설정 (0: 일요일)
        masks: {
            L: 'YYYY-MM-DD',
            title: 'MMMM YYYY',
            weekdays: 'WWW' 
          // 더 많은 마스크 포맷을 여기에 추가할 수 있습니다.
        }
      }
    },
    locale: 'ko-KR' // 기본 로케일 설정
});

const refreshFire = async () => {
    store.dispatch('clearVehicleData');
    store.dispatch('IotResult/clearResult');
    store.dispatch('clearDataItems');
    store.dispatch('setGroupId', null);
    store.dispatch('setLoginGroup', null);
    store.commit('setCurrentPage', 1);
    store.dispatch('setVinId', '');
    store.dispatch('setActiveMenu', null);
    store.dispatch('resetAllParams');
    store.dispatch('setIotState',null);
    store.dispatch('setAxiosLoading', false);
    store.dispatch('regiSave/clearRegiTemp');
    store.dispatch('clearPermission');
    await router.push({ name: 'login' });
    window.location.reload();
};

//const autoLoginData = (localStorage.getItem('autoLogin') ==="true") || false; //autoLogin 주석처리

const refresh = async () => {
    const token = store.getters['loginModule/getRefreshToken'];
    if (token) {
    //if (token && autoLoginData) { //autoLogin 주석처리
        // let params = {
        //     autoLogin: autoLoginData || false
        // }
        
            //await axios.get(`${process.env.VUE_APP_API_URL_AUTH}/api/auth/refreshToken`, { params }).then( async (response) => {  //autoLogin 주석처리
            // DDAT-1660: in-flight 싱글톤 공유 — useMapSessionKeepAlive ping 과 동시 호출 시
            // refresh 1회만 나가게 dedup (RT 회전 경합 → E0803 강제 로그아웃 차단)
            await callRefreshTokenSingleton(process.env.VUE_APP_API_URL_AUTH).then( async (response) => {
                const responseData = response.data;
                if (responseData.error) {
                    await refreshFire();
                    return false;
                } else if (responseData.success === true) {
                    const loginData = {
                        accessToken: responseData.data.accessToken,
                        refreshToken: responseData.data.refreshToken
                    };
                    await store.dispatch('loginModule/saveLoginData', loginData);

                    const loginId = store.state.loginModule.id;
                    await axios.get(`${process.env.VUE_APP_API_URL_API}/api/tms/member/detail/${loginId}`).then( async (response) => {
                        const responseData = response.data;
                        if (responseData.error) {
                            await refreshFire(responseData);
                        } else if (responseData.success === true) {
                            const name = responseData.data[0].name;
                            const group = responseData.data[0].groupId;
                            store.dispatch('loginModule/setName', name);
                            store.dispatch('setLoginGroup', group);
                            const groupIdToMatch = store.state.loginGroup;
                            await store.dispatch('setGroupId', groupIdToMatch);
                            await componentPermission();

                            window.location.reload();
                        }
                    }).catch(async (error) => {
                        await refreshFire();
                    });
                }
            }).catch( async (error) => {
                await refreshFire();
            });

    } else {
        await refreshFire();
    }
};

    app.config.globalProperties.$axios = axios;

    axios.interceptors.request.use( // 요청
        async (config) => {
            const token = store.getters['loginModule/getAccessToken'];
            const reToken = store.getters['loginModule/getRefreshToken'];
            //if (config.url === "https://iz8hmpwfrb.execute-api.ap-northeast-2.amazonaws.com/prod-trip-api/trip") {
            if (config.url === `${process.env.VUE_APP_API_OPERATIONDATA_CUSDETAIL_URL}`) {
                return config;
            }
            if (token) {
                if (config.url === `${process.env.VUE_APP_API_URL_API}/api/daedong/v1.0/customer/report`) {
                    // config.headers['X-AUTH-ACCESS-TOKEN'] = appToken;
                } else {
                    config.headers['X-AUTH-ACCESS-TOKEN'] = token;
                    config.headers['X-AUTH-REFRESH-TOKEN'] = reToken;
                }
            }
            store.dispatch('IotResult/clearErrorMsg');
            store.dispatch('IotResult/clearDefHeaterTest');
            store.dispatch('IotResult/clearDefControlTest');
            store.dispatch('IotResult/clearDefInjectTest');
            store.dispatch('IotResult/clearLeakTest');
            store.dispatch('IotResult/clearPrvTest');
            store.dispatch('clearTesting');

            return config;
        },
         async (error) => {
            if (error.response.data.error) {
                if (error.response.data.error.errorCode === 'E0802') {
                    await refresh();
                } else if (error.response.data.error.errorCode === 'E0803') {
                    await refreshFire();
                }
            }
            return error;
        }
    );

    axios.interceptors.response.use( async function (response) {
        if (response.data.error) {
            if (response.data.error.errorCode === 'E0802') {
                await refresh();
            } else if (response.data.error.errorCode === 'E0803') {
                const loginData = {
                    accessToken: null,
                    refreshToken: null
                };
                store.dispatch('loginModule/saveLoginData', loginData);
                await refreshFire();
            } else if (response.data.error.errorCode === 'E0105') {
                const loginData = {
                    accessToken: null,
                    refreshToken: null
                };
                store.dispatch('loginModule/saveLoginData', loginData);
                await refreshFire();
            }
        } else {
            const token = store.getters['loginModule/getAccessToken'];
            if(response.headers['x-auth-access-token']) {
                // DDAT-1660 (KR DDAT-698 포트): AT 만 갱신하고 RT 는 store 값을 유지한다.
                // refreshToken: null 로 덮으면 저장된 RT 가 지워져 이후 refresh·keep-alive 가 전부 무력화된다.
                const loginData = {
                    accessToken: response.headers['x-auth-access-token'],
                    refreshToken: store.state.loginModule.refreshToken,
                    credentialsNonExpired: store.state.loginModule.credentialsNonExpired
                };
                store.dispatch('loginModule/saveLoginData', loginData);
            }
        }
        return response;
        }, async function (error) {
            if (error.code == 'ERR_NETWORK') {
                return Promise.reject(error);
            }
            if (!error.response || !error.response.data) {
                return Promise.reject(error);
            }
            // DDAT-183: DB 점검 중 503 → 점검 안내 화면으로 이동 (display:0 이면 점검 페이지 비노출)
            if (error.response.status === 503 && window.__TMS_MAINTENANCE_CONFIG__?.display === 1) {
                router.push({ name: 'maintenance' });
                return Promise.reject(error);
            }
            if (error.response.data.error) {
                if (error.response.data.error.errorCode === 'E0802') {
                    await refresh();
                } else if (error.response.data.error.errorCode === 'E0803') {
                    const loginData = {
                        accessToken: null,
                        refreshToken: null
                    };
                    store.dispatch('loginModule/saveLoginData', loginData);
                    await refreshFire();
                } else if (error.response.data.error.errorCode === 'E0105') {
                    const loginData = {
                        accessToken: null,
                        refreshToken: null
                    };
                    store.dispatch('loginModule/saveLoginData', loginData);
                    await refreshFire();
                }
            }
            return Promise.reject(error);
        }
    );

    // =========== 등록화면에서 데이터 임시저장해놓은거 닫으면 지우는 부분
    const storeDataItems = store.getters.getDataItems;

    const pageActionMap = {
        modelRegi: 'clearModelRegi',
        faqRegi: 'clearFaqRegi',
        noticeRegi: 'clearNoticeRegi',
        postRegi: 'clearPostRegi',
        categoryRegi: 'clearCategory',
        shopBannerRegi: 'clearBanner',
        partDisplayRegi: 'clearParts',
        customerRegi: 'clearUserRegi',
        gptBannerRegi: 'clearGptBannerRegi'
    };

    watch(storeDataItems, (newVal, oldVal) => {
        const pageRegiStatus = {};

        Object.keys(pageActionMap).forEach(page => {
            pageRegiStatus[page] = false;
        });

        storeDataItems.forEach(item => {
        if (pageRegiStatus.hasOwnProperty(item.page)) {
            pageRegiStatus[item.page] = true;
        }
        });

        Object.entries(pageRegiStatus).forEach(([page, isRegistered]) => {
        if (!isRegistered) {
            const action = pageActionMap[page];
            if (action) {
            store.dispatch(`regiSave/${action}`);
            }
        }
        });
    }
    );
    function injectApiParams(accessToken, vinId){
        router.push({ name: 'reportDetailAppMng', params: { accessToken, vinId } })
    };

async function fetchMaintenanceConfig() {
    const url = process.env.VUE_APP_MAINTENANCE_CONFIG_URL;
    if (!url) return null;
    try {
        const res = await Promise.race([
            fetch(url, { cache: 'no-store' }),
            new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 3000)),
        ]);
        if (!res.ok) return null;
        return await res.json();
    } catch {
        return null;
    }
}

(async () => {
    window.__TMS_MAINTENANCE_CONFIG__ = await fetchMaintenanceConfig();

    const _mpParam = new URLSearchParams(window.location.search).get('_mp');
    if (_mpParam === '1') localStorage.setItem('__tms_mp', '1');
    else if (_mpParam === '0') localStorage.removeItem('__tms_mp');

    app.mount('#app');

    // beforeEach 타이밍 보완: 초기 네비게이션 완료 후 강제 점검(display:2) 또는 미리보기이면 이동
    await router.isReady();
    const cfg = window.__TMS_MAINTENANCE_CONFIG__;
    const inPreview = localStorage.getItem('__tms_mp') === '1';
    const _now = Date.now();
    const inSchedule = cfg?.display === 1 && cfg?.start && cfg?.end
        && _now >= new Date(cfg.start).getTime() && _now <= new Date(cfg.end).getTime();
    if ((cfg?.display === 2 || inSchedule || inPreview) && router.currentRoute.value.name !== 'maintenance') {
        router.replace({ name: 'maintenance' });
    }
})();